import '../../CSS/Empleados.css'
import React, { useEffect, useState } from 'react';
import { URI } from '../../Conexiones/Conexion';
import '../../CSS/Empleados.css'
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router';
import { getToken } from '../../Conexiones/Conexion';
import moment from 'moment';

const ModalConfPagos = () => {

    const [pagos,setPagos]=useState([])
    const [ofi,setOfi]=useState([])
    const navigate = useNavigate()
    const [lista,setLista]=useState([])
    const [fecha,setFecha] = useState('')


    const faltaConfirmar = async () =>{
        Swal.fire({
            title: '¡ERROR!',
            text: 'FALTAN EMPLEADOS POR CONFIRMAR',                 
            icon: 'error',
            confirmButtonColor: 'red',
            allowOutsideClick: false,
            confirmButtonText: 'ACEPTAR'
        })
    }

    

    useEffect (()=>{
        const getPagosOfi = async () =>{
            const res = await axios.get(URI+'pagosOficina',{
                headers: {
                    'Authorization': `Bearer ${getToken()}`
                },
                }).catch(
                    err =>{
                        if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                            navigate('/')
                        }
                    }
                )
            console.log(res.data)
            setPagos(res.data)
            setOfi(res.data)
        }
        getPagosOfi()
    },[navigate])

    const getPagosOfiAtrasados = async (fechaIngresada) =>{
        const res = await axios.get(URI+'pagosOficina/'+fechaIngresada,{
            headers: {
                'Authorization': `Bearer ${getToken()}`
            },
            }).catch(
                err =>{
                    if(err.response.data === "Token Inválido" | err.response.data === "Token requerido"){
                        navigate('/')
                    }
                }
            )
        console.log(res.data)
        setPagos(res.data)
        setOfi(res.data)

        for (var i = 0; i < pagos.length; i++) { //desmarcar los checkbox
            document.getElementById(`cb${pagos[i].idEmpleado}`).checked = false;
                var inext = document.getElementById(`ex${pagos[i].idEmpleado}`)
                inext.value=""
                inext.disabled = false
        }

        lista.length = 0 //limpiar lista
    }

    const confirmarPago = async (id,cod,nom,apeP,apeM) =>{
        var cantExtra = parseFloat(document.getElementById(`ex${id}`).value)
        if(cantExtra <=0 ){
            Swal.fire({
                title: '¡ERROR!',
                text:'LA CANTIDAD INGRESADA DEBE SER MAYOR A 0...',                 
                icon: 'error',
                confirmButtonColor: 'red',
                confirmButtonText: 'ACEPTAR'
            })
        }else{
            const filtrar = await ofi.filter(emp => emp.idEmpleado === id);
            if(document.getElementById(`cb${id}`).checked){
                if(Number.isNaN(cantExtra) ){
                    const newRegistro = {
                        idEmpleado:id,
                        codigo:cod,
                        nameEmp:nom,
                        apeP:apeP,
                        apeM:apeM,
                        extra:0,
                        dias:filtrar[0].dias,
                        precio:filtrar[0].precio,
                        total:filtrar[0].total
                    }
                        setLista([...lista,newRegistro])
                }else{
                    const newRegistro = {
                        idEmpleado:id,
                        codigo:cod,
                        nameEmp:nom,
                        apeP:apeP,
                        apeM:apeM,
                        extra:cantExtra,
                        dias:filtrar[0].dias,
                        precio:filtrar[0].precio,
                        total:filtrar[0].total+cantExtra
                    }
                        setLista([...lista,newRegistro])
                }
                
            }else{
                const eliminar = lista.filter((item) => item.idEmpleado !== id) ;
                setLista(eliminar)
            }
        }
        console.log(lista)
    }
    const guardarPagos = async (e) => {
        e.preventDefault()
        var semana='';
        var fechaFormat = '';
        if (fecha===''){
            var getdatetime = new Date();
            semana = moment(getdatetime,"DD-MM-YYYY").isoWeek()
            fechaFormat  = moment(getdatetime).format("YYYY-MM-DD")
        }else{
            semana = moment(fecha,"YYYY-MM-DD").isoWeek()
            fechaFormat  = moment(fecha).format("YYYY-MM-DD")
        }
        var listPagos = JSON.stringify(lista);
        await axios.post(URI+'guardarPagos/',{lista:listPagos,semana:semana,fechaFormat:fechaFormat},{
            headers: {
                'Content-Type': 'application/json',
            },
            }).then(
            res => {
                if(res.data.message === "connect ECONNREFUSED 127.0.0.1:3306"){
                    Swal.fire(
                        'Falla en el servidor...',
                        'Intente más tarde',
                        'question'
                        )
                }else{
                    if(res.data.message==="SE GUARDÓ EL REGISTRO CORRECTAMENTE"){
                        Swal.fire({
                            icon: 'success',
                            title: res.data.message,
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate('/inicio/Oficina/PagosOficina')
                                window.location.reload();
                            } 
                        })
                    }else{
                        Swal.fire({
                            title: '¡ERROR!',
                            text: res.data.message,                 
                            icon: 'error',
                            confirmButtonColor: 'red',
                            allowOutsideClick: false,
                            confirmButtonText: 'ACEPTAR'
                        })
                    }
                }
            }
        ).catch(
            err => {
                if(err.message === "Network Error"){
                    Swal.fire(
                        'Falla en el servidor...',
                        'Intente más tarde',
                        'question'
                    )
                }else{
                    Swal.fire(
                        'Falla en el servidor...',
                        err.message,
                        'question'
                    )
                }
            }
        )
    }

    const cancelar = async () => {
        if(lista.length === 0 ){
            window.location.reload()
        }else{
            Swal.fire({
                title: '¿SEGURO QUE QUIERES SALIR?',
                text: "UNA VEZ CANCELADO SE ELIMINARAN LOS CAMBIOS",
                icon: 'warning',
                iconColor:'#1e2c4f',
                color: '#1e2c4f',
                showCancelButton: true,
                confirmButtonColor: '#1e2c4f',
                cancelButtonColor: '#d33',
                confirmButtonText: 'SALIR',
                cancelButtonText: 'CANCELAR'
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate('/inicio/oficina/PagosOficina')
                    window.location.reload()
                }
            })   
        } 
    }


    return (
        <div>            
        <div className="modal fade" id="modal-pagos-ofi" data-bs-backdrop="static"  tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-fullscreen">
                <div className="modal-content">
                    <div className="modal-header btncolor" >
                        <h5 className="modal-title " id="exampleModalLabel">REGISTRAR PAGOS OFICINA</h5>
                        <button type="button"  className="btn-close bg-white"  onClick={cancelar} data-bs-dismiss="modal" aria-label="Close" ></button>
                    </div>
                    <div className="modal-body" >

                    <div className="fecha" style={{display:'flex', justifyContent:'space-between'}}>
                                    <input type="date" className="form-control" required value={fecha} onChange={(e)=>setFecha(e.target.value)}  aria-describedby="basic-addon1"/>   
                                    <button type="button" className="btn btncolor"  onClick={()=> getPagosOfiAtrasados(fecha)}  >BUSCAR</button>                                                
                    </div>

                    { pagos.length === 0 ? (<h3 style={{marginTop:'30vh'}}>NO HAY REGISTROS</h3>):(
                        <div className="caja-asistencia" >
                            <div className="table tabla">
                                <table className="table  text-uppercase">
                                    <thead >
                                        <tr >
                                            <th>CODIGO</th>
                                            <th>CONCEPTO</th>
                                            <th>DIAS</th>
                                            <th>PRECIO</th>
                                            <th>EXTRA</th>
                                            <th>TOTAL</th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                    { pagos.map( pagoOfi => {
                                        return (
                                                <tr key={pagoOfi.idEmpleado}>
                                                <td>{pagoOfi.codigoEmp}</td>
                                                <td>{pagoOfi.nombreEmp}{' '}{pagoOfi.apellidoPaternoEmp}{' '}{pagoOfi.apellidoMaternoEmp}</td>
                                                <td>{pagoOfi.dias}</td>
                                                <td>$ {pagoOfi.precio}</td>
                                                <td>
                                                        <input type="number" id={`ex${pagoOfi.idEmpleado}`}  />
                                                </td>
                                                <td>$ {pagoOfi.total}</td>
                                                <td><input className="form-check-input" type="checkbox" id={`cb${pagoOfi.idEmpleado}`} 
                                                               onClick={()=> confirmarPago(pagoOfi.idEmpleado,pagoOfi.codigoEmp, pagoOfi.nombreEmp, 
                                                                pagoOfi.apellidoPaternoEmp,pagoOfi.apellidoMaternoEmp, pagoOfi.apellidoMaternoEmp
                                                                )}
                                                                />
                                                        </td>
                                                </tr>
                                        )
                                    })
                                }                 
                                    </tbody>
                                </table>
                            </div>           
                        </div>
                          )}
                    </div>
                    <div className="modal-footer justify-content-center foot" >
                            <button type="button" className="btn btn-secondary"  onClick={cancelar}>CANCELAR</button>
                            {lista.length === 0 ? (
                                <button type="button" className="btn btncolor" disabled >ACEPTAR</button>
                            ):(
                                pagos.length === lista.length ? (
                                    <button type="button" className="btn btncolor" data-bs-toggle="modal" data-bs-target="#modal-verificar-pago" >ACEPTAR</button>
                                ):(
                                    <button type="button" className="btn btncolor" onClick={faltaConfirmar} >ACEPTAR</button>
                                )
                            )}
                        </div>
                </div>
            </div>
        </div>
        <div className="modal fade" id="modal-verificar-pago" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header btncolor" >
                            <h5 className="modal-title" id="exampleModalLabel">VERIFICAR PAGO</h5>
                            <button type="button" className="btn-close bg-white" data-bs-toggle="modal" data-bs-target="#modal-pagos" aria-label="Close" ></button>
                        </div>
                        <div className="modal-body" >
                            <div className="mb-6">
                                <strong><label className="form-label">LISTA DE PAGOS</label></strong>
                            </div>
                            <div className="mb-6">
                                <label className="form-label"><strong>NOTA: </strong> SI LOS DATOS ESTAN CORRECTOS OPRIMA CONFIRMAR </label>
                            </div>
                            <div className="mb-6" >
                                <div className="table-responsive" >
                                    <table style={{width:'100%'}} className="table  text-uppercase">
                                        <thead >
                                            <tr >
                                                <th>CODIGO</th>
                                                <th>EMPLEADO</th>
                                                <th>DIAS</th>
                                                <th>PAGO</th>
                                                <th>EXTRA</th>
                                                <th>TOTAL</th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {lista.map(l =>{
                                                return(
                                                    <tr key={l.idEmpleado}>
                                                        <td>{l.codigo}</td>
                                                        <td>{l.nameEmp}{' '}{l.apeP}{' '}{l.apeM}</td>
                                                        <td>{l.dias}</td>
                                                        <td>{l.precio}</td>
                                                        <td>{l.extra}</td>
                                                        <td>{l.total}</td>
                                                    </tr>                   
                                                )
                                            })}                        
                                        </tbody>
                                    </table>
                                </div>           
                            </div>             
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#modal-pagos-ofi">CANCELAR</button>                                               
                            <button type="button" className="btn btncolor" onClick={guardarPagos} >CONFIRMAR</button>                                                
                        </div>
                    </div>
                </div>
            </div>
       
    </div>
    );
};

export default ModalConfPagos;